import {
  Range as SliderRange,
  Root as SliderRoot,
  Thumb as SliderThumb,
  Track as SliderTrack,
} from '@radix-ui/react-slider';
import { useEffect, useState } from 'react';

import styles from './RangeSlider.module.scss';

export type RangeSliderProps = {
  min: number;
  max: number;
  step: number;
  name?: string;
  value: number[];
  direction: 'rtl' | 'ltr';
  inverted?: boolean;
  isResetted?: boolean;
  defaultValue?: number[];
  containerClass?: string;
  onValueChange: (_: number[]) => void;
  onValueCommit: (_: number[]) => void;
};

export const RangeSlider = ({
  min,
  max,
  step,
  name,
  inverted,
  direction,
  isResetted,
  defaultValue,
  containerClass,
  onValueChange,
  onValueCommit,
}: RangeSliderProps) => {
  const [newValue, setNewValue] = useState([min, max]);
  const handleValueChange = (valueRange: number[]) => {
    let newValues = valueRange.map((val) => {
      let newVal;
      if (val === min) {
        return min;
      }
      if (val === max) {
        return max;
      }
      if (val > min && val <= 50) {
        newVal = Math.log10(val) + 1;
        return +newVal.toFixed(2);
      }
      if (val > 50 && val < max) {
        newVal = (val - 50) * 1.8 + 2;
        return +newVal.toFixed(2);
      }
      return +val.toFixed(2); // Se il valore non rientra in nessuna delle condizioni precedenti, restituisci il valore originale
    });
    onValueChange && onValueChange(newValue);
    onValueCommit && onValueCommit(newValue);
    setNewValue(newValues);
  };

  useEffect(() => {
    if (isResetted) {
      setNewValue([min, max]);
    }
  }, [isResetted, max, min]);

  return (
    <div className={containerClass}>
      {name && <span className={styles.title}>{name}</span>}
      <div className={styles.container}>
        <SliderRoot
          min={min}
          max={max}
          dir={direction}
          step={step}
          inverted={inverted}
          className={styles.slider}
          aria-label={name}
          defaultValue={defaultValue}
          minStepsBetweenThumbs={1}
          onValueChange={handleValueChange}
          onValueCommit={handleValueChange}
        >
          <SliderTrack className={styles.track}>
            <SliderRange className={styles.range} />
          </SliderTrack>
          <SliderThumb className={styles.thumb} />
          <SliderThumb className={styles.thumb} />
        </SliderRoot>
        <span className={styles.valuePrev}>{newValue[0]}</span>
        <span className={styles.valueNext}>{newValue[1]}</span>
      </div>
    </div>
  );
};
